import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../footer/Footer.css";
import "../footer/MobileFooter.css";
import CopyRights from "./CopyRights";
import {
  FaLinkedinIn,
  FaInstagram,
  FaWhatsapp,
  FaFacebookF,
} from "react-icons/fa";

const Footer = () => {
  return (
    <>
      <footer className="cyber_footer" id="footer">
        <div className="footer_glow_top"></div>
        <Container>
          <Row className="footer_main">
            <Col lg="4" className="mb-5 mb-lg-0">
              <div className="footer_brand">
                <h2 className="brand_logo">Zentexus<span>.com</span></h2>
                <p className="brand_mission">
                  Empowering businesses with cutting-edge digital solutions. From custom software to scalable mobile apps, we build the future of tech.
                </p>
                <div className="footer_social">
                  <a href="https://www.linkedin.com/company/zentexus-technologies/" target="_blank" rel="noopener noreferrer" className="social_link li" aria-label="LinkedIn"><FaLinkedinIn /></a>
                  <a href="https://www.instagram.com/zentexus_tech" target="_blank" rel="noopener noreferrer" className="social_link ig" aria-label="Instagram"><FaInstagram /></a>
                  <a href="https://wa.me/919363762876?text=Hello%20Zentexus%2C%20I%20would%20like%20to%20know%20more%20about%20your%20services." target="_blank" rel="noopener noreferrer" className="social_link wa" aria-label="WhatsApp"><FaWhatsapp /></a>
                  <a href="https://www.facebook.com/profile.php?id=61558438476589" target="_blank" rel="noopener noreferrer" className="social_link fb" aria-label="Facebook"><FaFacebookF /></a>
                </div>
              </div>
            </Col>

            <Col lg="8">
              <Row>
                <Col md="4" className="mb-4 mb-md-0">
                  <div className="footer_nav_group">
                    <h5 className="footer_heading">Quick Links</h5>
                    <ul className="footer_links">
                      <li><Link to="/">Home</Link></li>
                      <li><Link to="/about">About Us</Link></li>
                      <li><Link to="/services">Services</Link></li>
                      <li><Link to="/contactus">Contact</Link></li>
                    </ul>
                  </div>
                </Col>

                <Col md="4" className="mb-4 mb-md-0">
                  <div className="footer_nav_group">
                    <h5 className="footer_heading">Legal & Policy</h5>
                    <ul className="footer_links">
                      <li><Link to="/privacy">Privacy Policy</Link></li>
                      <li><Link to="/terms">Terms of Service</Link></li>
                      <li><Link to="/refund">Refund Policy</Link></li>
                    </ul>
                  </div>
                </Col>

                <Col md="4">
                  <div className="footer_nav_group">
                    <h5 className="footer_heading">Contact Info</h5>
                    <ul className="footer_contact">
                      <li>
                        <span className="contact_label">Email:</span>
                        <a href="mailto:info@zentexus.com">info@zentexus.com</a>
                      </li>
                      <li>
                        <span className="contact_label">Phone:</span>
                        <a href="tel:+919363762876">+91 93637 62876</a>
                      </li>
                      <li className="location">
                        <span className="contact_label">Location:</span>
                        <p>Virudhunagar, Tamil Nadu, India</p>
                      </li>
                    </ul>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </footer>
      <CopyRights />
    </>
  );
};

export default Footer;